package ui.components

import api.data.DataProperty
import api.repository.properties.ImplRepositoryProperties
import api.service.properties.ImplServiceProperties
import kotlinx.browser.window
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.launch
import kotlinx.css.tr
import react.FC
import react.Props
import react.dom.html.ReactHTML.img
import react.dom.html.ReactHTML.p
import web.cssom.ClassName
import web.html.HTMLDivElement
import react.dom.html.ReactHTML.button
import web.html.HTMLElement
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.span
import react.dom.html.ReactHTML.picture
import react.dom.html.ReactHTML.source
import react.dom.html.ReactHTML.section
import react.dom.html.ReactHTML.h2
import react.dom.html.ReactHTML.h3
import react.dom.html.ReactHTML.h4
import react.dom.html.ReactHTML.h5
import react.dom.html.ReactHTML.h6
import react.dom.html.ReactHTML.label
import react.dom.html.ReactHTML.input
import react.dom.html.ReactHTML.form
import react.dom.html.ReactHTML.ul
import react.dom.html.ReactHTML.li
import routes.EnumRoutes
import web.prompts.alert

external interface ComponentPropertyRowProps : Props {
    var property: DataProperty
    var className: ClassName?
}

val ComponentPropertyRow = FC<ComponentPropertyRowProps> { props ->
    val property = props.property

    div {
        className = ClassName("flex flex-col md:flex-row md:items-center gap-4 p-4 border-b border-border ${props.className ?: ""}")
//        onClick = {
//            window.location.href = "${EnumRoutes.PropertyListing.routeID}?id=${property.id}"
//        }
        // Mobile Layout
        div {
            className = ClassName("md:hidden space-y-3")

            div {
                className = ClassName("flex items-center gap-3")

//                Property Image
                div {

                    className = ClassName("w-8 h-8 bg-gray-200 rounded-full overflow-hidden flex-shrink-0")
                    img {
                        src = property.images?.get(0)
                        alt = property.title
                        className = ClassName("w-full h-full object-cover")
                    }
                }

//                Property Title
                div {
                    onClick = {
                        window.location.href = "${EnumRoutes.PropertyListing.routeID}?id=${property.id}"
                    }
                    className = ClassName("flex-1 min-w-0")
                    p {
                        className = ClassName("text-sm text-foreground font-normal font-serif")
                        +property.title
                    }
                    p {
                        className = ClassName("text-xs text-boon-muted font-serif")
                        +property.location
                    }
                }

                div {
                    className = ClassName("flex items-center gap-2")
                    button {
                        className = ClassName("p-1 hover:bg-accent rounded transition-colors")
                        // Edit Icon placeholder
                    }
                    span {
                        onClick = {
                            window.location.href = "${EnumRoutes.EditProperty.routeID}?id=${property.id}"
                        }
                        +"✏️"

                    }
                    button {
                        className = ClassName("p-1 hover:bg-accent rounded transition-colors")

                        // Trash Icon placeholder
                        span { +"🗑️"
                            onClick = {
//                            Delete Property

//                                console.log("deleting this property")
                            }
                        }
                    }
                }
            }

            div {
                className = ClassName("flex justify-between text-xs")
                span { className = ClassName("text-foreground font-serif"); +"${property.price.toString()} ${property.currency}" }
                span { className = ClassName("text-foreground font-serif"); +property.status }
//                span {
//                    className = ClassName("text-foreground font-serif")
//                    +when (property.inquiries) {
//                        0 -> "0 inquiries"
//                        1 -> "1 inquiry"
//                        else -> "${property.inquiries} inquiries"
//                    }
//                }
            }
        }

        // Desktop Layout
        div {
            className = ClassName("hidden md:flex md:items-center md:gap-4 md:w-full")

            div {
                onClick = {
                    window.location.href = "${EnumRoutes.PropertyListing.routeID}?id=${property.id}"
                }
                className = ClassName("flex items-center gap-4 flex-1")
                div {
                    className = ClassName("w-8 h-8 bg-gray-200 rounded-full overflow-hidden flex-shrink-0")
                    img {
                        src = property.images?.get(0)
                        alt = property.title
                        className = ClassName("w-full h-full object-cover")
                    }
                }
                div {
                    className = ClassName("flex-1 min-w-0")
                    p {
                        className = ClassName("text-sm text-foreground font-normal font-serif")
                        +property.title
                    }
                }
            }

            div {
                className = ClassName("flex-1 min-w-0")
                p {
                    className = ClassName("text-sm text-foreground font-normal font-serif")
                    +property.location
                }
            }

            div {
                className = ClassName("w-32 text-right")
                p {
                    className = ClassName("text-sm text-foreground font-normal font-serif")
                    +"${property.price} ${property.currency}"
                }
            }

            div {
                className = ClassName("w-28 text-center")
                p {
                    className = ClassName("text-sm text-foreground font-normal font-serif")
                    +property.status
                }
            }

//            div {
//                className = ClassName("w-32 text-center")
//                p {
//                    className = ClassName("text-sm text-foreground font-normal font-serif")
//                    +when (property.inquiries) {
//                        0 -> "0 inquiries"
//                        1 -> "1 inquiry"
//                        else -> "${property.inquiries} inquiries"
//                    }
//                }
//            }

            div {
                className = ClassName("flex items-center gap-2 w-16")
                button {
                    onClick = {
                        window.location.href = "${EnumRoutes.EditProperty.routeID}?id=${property.id}"
                    }
                    className = ClassName("p-1 hover:bg-accent rounded transition-colors")
                    span { +"✏️" }
                }
                button {
                    onClick = {
                        if (kotlinx.browser.window.confirm("Are you sure you want to delete this invoice?")){
                            CoroutineScope(Dispatchers.Main).launch {
                                deleteProperty(property)
                            }
                        }
                    }
                    className = ClassName("p-1 hover:bg-accent rounded transition-colors")
                    span { +"🗑️" }
                }
            }
        }
    }
}


private suspend fun deleteProperty(dataProperty: DataProperty){
    val implRepoDelete = ImplRepositoryProperties(ImplServiceProperties).removeProperty(dataProperty)
    if(implRepoDelete){
        window.location.reload()
    } else {
        alert("Delete unsuccessful")
    }
}